"use client"

import { Moon, Sun } from 'lucide-react'
import { useTheme } from 'next-themes'

import { useHydrated } from '@/hooks/use-hydrated'

export function PublicTopControls() {
  const { theme, resolvedTheme, setTheme } = useTheme()
  const mounted = useHydrated()
  const isDark = (resolvedTheme ?? theme ?? 'dark') === 'dark'
  const label = !mounted
    ? 'Cambiar tema'
    : isDark
      ? 'Cambiar a tema claro'
      : 'Cambiar a tema oscuro'

  return (
    <div className="absolute right-4 top-4 z-20 flex items-center gap-2 sm:right-6 sm:top-6">
      <button
        type="button"
        aria-label={label}
        title={label}
        onClick={() => mounted && setTheme(isDark ? 'light' : 'dark')}
        className="inline-flex h-9 w-9 items-center justify-center rounded-lg border border-border bg-card text-muted-foreground transition-colors hover:bg-accent hover:text-foreground"
      >
        {mounted && isDark ? <Sun size={16} /> : <Moon size={16} />}
      </button>
    </div>
  )
}
